import React, { useEffect, useState } from 'react'
import { UseRangeProps, useRange } from 'react-instantsearch'

import ItemCheckbox from 'components/atoms/item-checkbox'
import ItemSelectContainer from 'components/organisms/item-select-container'

export type RangeSelectInfo = {
  label: string
  value: number[]
}

type RangeSelectListProps = {
  genRangeInfos: (RangeMin: number, RangeMax: number) => RangeSelectInfo[]
} & UseRangeProps

const INFINITY_RANGE_MAX = 999999999

const RangeSelectList = ({ genRangeInfos, ...props }: RangeSelectListProps) => {
  const { range, start, refine } = useRange(props)
  const rangeMin = range.min ?? 0
  const rangeMax = range.max ?? INFINITY_RANGE_MAX

  const [selectedRange, setSelectedRange] = useState<string[]>([])

  useEffect(() => {
    // init selected range
    const initMin = start[0] === -Infinity ? rangeMin : start[0]
    const initMax = start[1] === Infinity ? rangeMax : start[1]

    setSelectedRange([[initMin, initMax].toString()])
    refine([initMin, initMax])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rangeMin, rangeMax])

  const rangeInfos = genRangeInfos(rangeMin, rangeMax)
  return (
    <ItemSelectContainer>
      {rangeInfos.map(({ label, value }, index) => {
        const isLastRange = index === rangeInfos.length - 1

        const upperBound = isLastRange ? range.max : value[1]

        const rangeValue = [[value[0], upperBound].toString()]
        const rangeValueString = rangeValue.toString()

        const isSelected = rangeValueString === selectedRange.toString()
        return (
          <ItemCheckbox
            key={rangeValueString}
            isSelected={isSelected}
            id={props.attribute + rangeValueString}
            label={label}
            name={rangeValueString}
            onChange={(isChecked) => {
              if (!isChecked) {
                refine([range.min, range.max])
                setSelectedRange([])
                return
              }

              refine([value[0], upperBound])
              setSelectedRange(rangeValue)
            }}
          />
        )
      })}
    </ItemSelectContainer>
  )
}

export default RangeSelectList
